<template>
  <a
    class="cookie__link"
    :href="url"
    @mouseenter="cursorToScroll()"
    @mouseleave="cursorToClose()"
    target="_blank"
    rel="noopener"
  >
    <span
      class="cookie__link-label"
      v-html="label"
    />
  </a>
</template>

<script>
export default {
  name: 'CookieLink',

  props: {
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },

  methods: {
    cursorToScroll() {
      this.$eventHub.$emit('soundInteraction');
      this.$eventHub.$emit('cursorToZoom');
    },

    cursorToClose() {
      if (!this.$store.state.scrollIsLocked) {
        this.$eventHub.$emit('cursorToClose');
      } else {
        this.$eventHub.$emit('cursorToScroll');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  position: relative;

  span {
    color: #B3B3B3;
  }

  &::before {
    content: '';

    position: absolute;
    bottom: -2px;
    left: 0;
    width: 100%;
    height: 1px;

    background-color: #B3B3B3;
    transform-origin: 0% 50%;
    transition: transform 0.5s $inOutQuint;
    transform: scaleX(0);
  }

  &:hover::before {
    transform: scaleX(1);
  }
}

</style>
